export const equipmentModelMixin = {
  data() {
    return {
      equipmentModelObj: {
        description: null,
        isWeighted: false,
        label: '',
        maxWeight: null,
        mediaAssets: {
          coverPhoto: {
            url: null,
          },
          thumbnailPhoto: {
            url: null,
          },
        },
        minWeight: null,
        org_id: null,
        requiredEquipment: {
          weighted: null,
          unweighted: [],
        },
        trainer_id: '0',
        type: 'main',
        user_id: '0',
      },
    };
  },
  methods: {
    getEquipmentModel() {
      return this.equipmentModelObj;
    },
  },
};
